// Utilities for threading the MCP OAuth flow id through the existing auth +
// org/workspace setup flows. The flow id arrives at /auth as a query param
// (?oauth_flow=<id>) when a third party (e.g. Claude) redirects the user to
// authorize. We persist it in localStorage so it survives multi-step setup
// (signup → confirm code → login → org creation → workspace creation), then
// drain it once the user reaches the consent page.

const KEY = 'vairo_oauth_flow';

export function captureOAuthFlowFromUrl(searchParams) {
  // Accept either `oauth_flow` (used by /auth from the OAuth redirect) or
  // `flow` (used by /oauth-consent).
  const flowId = searchParams?.get?.('oauth_flow') || searchParams?.get?.('flow');
  if (flowId) {
    try { localStorage.setItem(KEY, flowId); } catch { /* ignore */ }
  }
  return flowId || getStoredOAuthFlow();
}

export function getStoredOAuthFlow() {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function clearStoredOAuthFlow() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}

/**
 * Default destination after successful login / org / workspace setup.
 * When an MCP OAuth flow is in progress, route the user to the consent page;
 * otherwise fall back to /forecast.
 */
export function getPostAuthDestination(fallback = '/forecast') {
  const flowId = getStoredOAuthFlow();
  return flowId ? `/oauth-consent?flow=${flowId}` : fallback;
}
